import { safeDefine } from "../../registration/safe-define.js";
import { TimeSliderChapterTitleElement } from "../../ui/time-slider/chapter-title.js";
//#region src/define/ui/time-slider-chapter-title.ts
safeDefine(TimeSliderChapterTitleElement);
//#endregion

//# sourceMappingURL=time-slider-chapter-title.js.map